export function has_some_error(state: any, action: any) {
  return {
    ...state,
    hasSomeError: {
      error: action.show,
      message: action.message,
    },
  };
}
